import alert from '../components/core/Alert';
import { humanize } from './formatter';

export const errorItems = (object: string[] | Record<string, any>) => {
  if (object instanceof Array) {
    return object.map(item => humanize(item));
  }

  return Object.entries(object).map(([key, value]) =>
    humanize(typeof value === 'string' || value instanceof String ? `${key} ${value}` : JSON.stringify(value))
  );
};

const errorMessage = (data: any) => (typeof data.message?.message === 'string' ? data.message.message : data.message);

export const apiErrorReasons = (response: any): string[] | null => {
  const data = response?.data || {};

  if (data.status === 'error') {
    const message = errorMessage(data);

    return message instanceof Array ? errorItems(message) : [`${message}`];
  }

  if (data.status === 'fail') {
    return errorItems(data.data);
  }

  if (data.errors instanceof Array) {
    return data.errors;
  }

  return null;
};

const alertFromApiResponse = (response: any) => {
  const reasons = apiErrorReasons(response);

  if (!reasons) {
    return alert({ message: 'Response has wrong format' }).error();
  }

  if (response.data.status === 'error' && !(errorMessage(response.data) instanceof Array)) {
    return alert({ message: `Can't perform operation. Error(s): ${reasons[0]}` }).error();
  }

  return alert({ message: ' ', title: "Can't perform operation. Error(s): ", items: reasons }).error();
};

export const genericNetworkError = () =>
  alert({
    message:
      'For AMP to work perfectly, please refresh the page. Just a heads-up, any unsaved changes might not make it through the reload.',
    title: 'It seems like your connection has hiccuped!'
  }).error();

export default alertFromApiResponse;
